import { Component, OnInit } from '@angular/core';
import { environment } from '@Env/environment';
@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit {
  environment = environment;
  constructor() { }

  ngOnInit() {
  }

}
